import { render, staticRenderFns } from "./StockPurchaseOrderListNew.vue?vue&type=template&id=6111f104&"
import script from "./StockPurchaseOrderListNew.vue?vue&type=script&lang=js&"
export * from "./StockPurchaseOrderListNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports